export const eliminateArrayDuplicates = <T>(data: T[]) => Array.from(new Set(data));